import React, { useState, useEffect } from "react";
import Layout from "../components/layout";
import axios from "axios";
import { endpoint } from "../App";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-modal";
import { IoClose } from "react-icons/io5";
import Spinner from "../components/spinner";

const Users = () => {
  const [users, setUsers] = useState([]);

  const accessToken = localStorage.getItem("accessToken");

  const [password, setPassword] = useState("");

  const [formData, setFormData] = useState("");
  const [loading, setLoading] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const customId = 99999;
  const endpointHeaders = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  // const generatePassword = () => {
  //     const length = 10; // You can adjust the length of the password
  //     const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+{}[]|:;"<>,.?/~'; // Characters to include in the password
  //     let newPassword = '';
  //     for (let i = 0; i < length; i++) {
  //       const randomIndex = Math.floor(Math.random() * charset.length);
  //       newPassword += charset[randomIndex];
  //     }
  //     setPassword(newPassword);
  //     setFormData({
  //         ...formData,
  //         password: assword,
  //         password2: newPassword
  //     })
  //   };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "4px",
      borderWidth: "1px",
      padding: "16px",
      overflowY: "auto",
      maxHeight: "100vh",
      width: window.innerWidth < 1024 ? "90%" : "40%",
    },
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // generatePassword();
    console.log(formData);

    try {
      toast.loading("Loading...", { autoClose: false, toastId: customId });
      await axios.post(endpoint + "add_user/", formData, endpointHeaders);
      toast.dismiss();
      toast.success("User created succssfully", {
        toastId: customId,
        autoClose: 4000,
      });
      setIsOpen(false);
    } catch (error) {
      toast.dismiss();
      console.error("There was a problem with the request:", error.message);
      toast.error(error.message, {
        toastId: customId,
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  const activate = async () => {
    try {
      await axios.patch(endpoint + "users/1/activate/", null, endpointHeaders);
      toast.success("User activated succssfully!", {
        toastId: customId,
        autoClose: 4000,
      });
    } catch (error) {
      console.error("There was a problem with the request:", error.message);
      toast.error(error.message, {
        toastId: customId,
        autoClose: 4000,
      });
    }
  };

  const deactivate = async () => {
    try {
      await axios.patch(
        endpoint + "users/1/deactivate/",
        null,
        endpointHeaders
      );
      toast.success("User deactivated succssfully!", {
        toastId: customId,
        autoClose: 4000,
      });
    } catch (error) {
      console.error("There was a problem with the request:", error.message);
      toast.error(error.message, {
        toastId: customId,
        autoClose: 4000,
      });
    }
  };

  useEffect(() => {
    axios
      .get(endpoint + "users/", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setUsers(response.data);
        localStorage.setItem("totalUsers", response.data.length);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setSpinner(false);
      });
  }, []);

  function toastTimeOut() {
    setTimeout(() => {
      <ToastContainer autoClose={4000} />;
    }, 100);
  }

  return (
    <>
      {toastTimeOut()}
      <Layout>
        <div className="grid gap-y-4">
          <div action="" className="rounded border grid p-8 bg-white">
            <p className="font-bold text-lg">Create New Users</p>
            <p>Click the button below</p>
            <button
              className="w-full bg-blue-600 h-12 rounded text-white mt-8"
              onClick={openModal}
            >
              Create
            </button>
          </div>

          {spinner ? (
            <div className="grid mt-40">
              <div className="place-self-center">
                <Spinner />
              </div>
            </div>
          ) : (
            <>
              {users.length !== 0 ? (
                <div className="rounded border grid p-8 gap-8 bg-white">
                  {users.length === 0 ? "No generated complaints" : ""}
                  <div className="grid md:grid-cols-2 gap-8">
                    {users.map((x, key) => (
                      <div className="shadow-lg p-5 rounded" key={key}>
                        <p>
                          <span className="text-red-600">Name: </span>
                          {x.first_name + " " + x.last_name}
                        </p>
                        <p>
                          <span className="text-red-600">Email: </span>
                          {x.email}
                        </p>
                        <p>
                          <span className="text-red-600">Phone no: </span>
                          {x.phone_number}
                        </p>

                        <div className="grid grid-cols-2 gap-x-4">
                          <button
                            type="submit"
                            className="w-full bg-green-600 h-12 rounded text-white mt-8"
                            onClick={activate}
                          >
                            Activate
                          </button>
                          <button
                            type="submit"
                            className="w-full bg-red-600 h-12 rounded text-white mt-8"
                            onClick={deactivate}
                          >
                            Deactivate
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Add New User"
                  >
                    <button onClick={closeModal} className="float-right">
                      <IoClose size={20} className="text-blue-600 mb-4" />
                    </button>
                    <div className="shadow-sm clear-both p-4">
                      <h4 className="text-xl font-semibold mb-2">
                        Add New User
                      </h4>
                      <p>Please fill in the details below</p>
                      <form
                        action=""
                        className="grid gap-y-4 mt-4"
                        onSubmit={handleSubmit}
                      >
                        <div className="">
                          <label htmlFor="" className="">
                            First Name
                          </label>{" "}
                          <br />
                          <input
                            type="text"
                            className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                            placeholder={"firstName"}
                            name="first_name"
                            onChange={handleChange}
                          />
                        </div>

                        <div className="">
                          <label htmlFor="" className="">
                            Last Name
                          </label>{" "}
                          <br />
                          <input
                            type="text"
                            className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                            placeholder={"lastName"}
                            name="last_name"
                            onChange={handleChange}
                          />
                        </div>

                        <div className="">
                          <label htmlFor="" className="">
                            Email
                          </label>{" "}
                          <br />
                          <input
                            type="text"
                            className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                            placeholder={"email"}
                            name="email"
                            onChange={handleChange}
                          />
                        </div>

                        <div className="">
                          <label htmlFor="" className="">
                            Phone Number
                          </label>{" "}
                          <br />
                          <input
                            type="text"
                            className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                            placeholder={"phoneNumber"}
                            name="phone_number"
                            onChange={handleChange}
                          />
                        </div>

                        <div className="">
                          <label htmlFor="" className="">
                            Username
                          </label>{" "}
                          <br />
                          <input
                            type="text"
                            className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                            placeholder={"username"}
                            name="username"
                            onChange={handleChange}
                          />
                        </div>

                        <div className="">
                          <label htmlFor="" className="">
                            User Type
                          </label>{" "}
                          <br />
                          <select
                            name="user_type"
                            id=""
                            className="rounded h-11 w-full mt-1 p-2 border border-blue-400"
                            onChange={handleChange}
                            required
                          >
                            <option value="">-Select-</option>
                            <option value={1}>Admin</option>
                            <option value={2}>Staff</option>
                            <option value={3}>Student</option>
                          </select>
                        </div>

                        {formData.user_type == "2" ? (
                          <>
                            <div className="">
                              <label htmlFor="" className="">
                                Role
                              </label>{" "}
                              <br />
                              <input
                                type="text"
                                className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                                placeholder={"role"}
                                name="role"
                                onChange={handleChange}
                              />
                            </div>
                          </>
                        ) : formData.user_type == "3" ? (
                          <>
                            <div className="">
                              <label htmlFor="" className="">
                                Matric Number
                              </label>{" "}
                              <br />
                              <input
                                type="text"
                                className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                                placeholder={"matric_no"}
                                name="matric_no"
                                onChange={handleChange}
                              />
                            </div>

                            <div className="">
                              <label htmlFor="" className="">
                                Department
                              </label>{" "}
                              <br />
                              <select
                                className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                                placeholder={"department"}
                                name="department"
                                onChange={handleChange}
                              >
                                <option value="">-Select-</option>
                                <option value="1">Software Engineering</option>
                                <option value="2">Computer Science</option>
                              </select>
                            </div>

                            <div className="">
                              <label htmlFor="" className="">
                                Hostel
                              </label>{" "}
                              <br />
                              <select
                                name="hostel"
                                id=""
                                className="rounded h-11 w-full mt-1 p-2 border border-blue-400"
                                onChange={handleChange}
                                required
                              >
                                <option value="">-Select-</option>
                                <option value="101">Bethel Splendor</option>
                                <option value="102">Welch</option>
                                <option value="103">Samuel Akande</option>
                                <option value="104">Winslow</option>
                              </select>
                            </div>

                            <div className="">
                              <label htmlFor="" className="">
                                Room number
                              </label>{" "}
                              <br />
                              <input
                                type="text"
                                className="rounded h-11 w-full mt-1 p-1 border border-blue-400"
                                placeholder={"room"}
                                name="room_number"
                                onChange={handleChange}
                              />
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        <button
                          type="submit"
                          className="w-full bg-blue-600 h-12 rounded text-white mt-8"
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </Modal>
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </Layout>
    </>
  );
};

export default Users;
